<form [formGroup]="formsService.form" (ngSubmit)="this.submitForm()">

	<app-modular-form-control-input name="name"/>

	<app-invalid-feedback></app-invalid-feedback>
</form>
